import { Notify } from '@flexisaf/flexibull2';
import { put, takeLatest } from 'redux-saga/effects';
import httpClient, { apiWrapper } from '../../../utils/http-client';
import { handleError } from '../../../utils/utils';
import {
  fetchStudentIncoiceSummaryStart,
  receivePaymentFail,
  receivePaymentSuccess,
} from '../actions';
import invoiceActionTypes from '../types';

export function* receivePayment({ payload }) {
  const callback = payload.callback;
  delete payload.callback;
  try {
    const response = yield apiWrapper(() => httpClient.post(`/payments/offline`, payload));
    yield put(receivePaymentSuccess(response.data));
    Notify('Payment has been saved successfully.', { position: 'top-right' });
    yield put(fetchStudentIncoiceSummaryStart(payload.student_id));
    callback();
  } catch (error) {
    yield put(receivePaymentFail(error?.message));
    const err = handleError(error);
  }
}

export function* onReceivePaymentStart() {
  yield takeLatest(invoiceActionTypes.RECEIVE_PAYMENT_START, receivePayment);
}
